import { ConstructorSchema } from '@common/mapper/types';
import { PlatformAppDto } from '@data/_generated-api/platform-api/models/platform-app-dto';
import Morphism from 'morphism';
import { PlatformNavigationItemDto } from '@data/_generated-api/platform-api/models/platform-navigation-item-dto';
import { PlatformUserGroupDto } from '@data/_generated-api/platform-api/models/platform-user-group-dto';
import { PlatformPageFeatureDto } from '@data/_generated-api/platform-api/models/platform-page-feature-dto';
import { PlatformNavigationItemType } from '@data/_generated-api/platform-api/models/platform-navigation-item-type';
import { PlatformUserAccountDto } from '@data/_generated-api/platform-api/models/platform-user-account-dto';
import { by } from '@common/utils/array-utils';
import { PlatformDeviceDto } from '@data/_generated-api/platform-api/models/platform-device-dto';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { FeatureAuthorizationEntity } from '@/app/platform/platform-data/models/feature-authorization.entity';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';
import { DeviceEntity } from '@/app/platform/platform-data/models/device.entity';
import { PlatformPresentDeviceUserInfoDto } from '@data/_generated-api/platform-api/models/platform-present-device-user-info-dto';
import { PresentUserData } from '@/app/platform/platform-data/models/present-user-data';

const egiPlanSchema: ConstructorSchema<PlatformAppDto, EgiAppEntity> = {
  constructor: EgiAppEntity,
  schema: {
    machineName: src => src.machineName ?? '',
    poolName: src => src.poolName ?? '',
    rootNavigationItem: src => Morphism.map(NavigationItemEntity, src.rootNavigationItem)
  }
};

const navigationItemSchema: ConstructorSchema<PlatformNavigationItemDto, NavigationItemEntity> = {
  constructor: NavigationItemEntity,
  schema: {
    children: src => Morphism.map(NavigationItemEntity, src.children),
    order: src => (src.type === PlatformNavigationItemType.DoorklikPagina ? -1 : src.order),
    config: src => (src.configurationJson ? JSON.parse(src.configurationJson) : undefined)
  }
};

const userGroupSchema: ConstructorSchema<PlatformUserGroupDto, UserGroupEntity> = {
  constructor: UserGroupEntity,
  schema: {
    authorizations: src => Morphism.map(FeatureAuthorizationEntity, src.pageFeatures),
    memberIds: src => src.userAccounts.sort(by('displayName')).map(a => a.id)
  }
};

const featureAuthorizationSchema: ConstructorSchema<
  PlatformPageFeatureDto,
  FeatureAuthorizationEntity
> = {
  constructor: FeatureAuthorizationEntity,
  schema: {
    featureId: src => src.pageFeatureId,
    name: src => src.pageFeatureName
  }
};

const userAccountSchema: ConstructorSchema<PlatformUserAccountDto, UserAccountEntity> = {
  constructor: UserAccountEntity,
  schema: {
    hasAcceptedTerms: src => src.acceptedTerms,
    accountCreationMethod: src => Number(src.accountCreatedByMethod),
    groupIds: src => src.userGroups.map(g => g.id)
  }
};

const deviceSchema: ConstructorSchema<PlatformDeviceDto, DeviceEntity> = {
  constructor: DeviceEntity,
  schema: {}
};

const presentUserSchema: ConstructorSchema<PlatformPresentDeviceUserInfoDto, PresentUserData> = {
  constructor: PresentUserData,
  schema: { id: src => src.userAccountId }
};

export const upamDtoToModelSchemas: ConstructorSchema<any, any>[] = [
  egiPlanSchema,
  navigationItemSchema,
  userGroupSchema,
  featureAuthorizationSchema,
  userAccountSchema,
  deviceSchema,
  presentUserSchema
];
